import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { CompraNFeEntradaPedidosElegiveisRequest } from '../../requests/compras/compra-nfe-entrada-pedidos-elegiveis.request';
import { CompraNFeEntradaPedidosElegiveisResponse } from '../../responses/compras/compra-nfe-entrada-pedidos-elegiveis.response';

@Injectable({
  providedIn: 'root',
})
export class CompraNFeEntradaVinculoService extends CommonService {
  private readonly apiUrl: string = environment.urlApiCompras + 'CompraNFeEntradaVinculo';

  constructor(private httpClient: HttpClient) {
    super();
  }

  public pedidosElegiveis(
    request: CompraNFeEntradaPedidosElegiveisRequest
  ): Observable<CompraNFeEntradaPedidosElegiveisResponse> {
    return this.httpClient
      .post<CompraNFeEntradaPedidosElegiveisResponse>(`${this.apiUrl}/pedidosElegiveis`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
